export interface RRIInput<T> {
  fieldName: string;
  label: string;
  placeholder?: string;
  tooltip?: string;
  type?:
    | 'checkbox-horizontal'
    | 'radio-horizontal'
    | 'text'
    | 'email'
    | 'password'
    | 'tel'
    | 'url'
    | 'color';
  class?: string;
  customInputClass?: string;
  hideResetInput?: boolean;
  hidecalendarButton?: boolean;
  disableClearEvent?: boolean;
  defaultValue?: T;
  showDateRanges?: boolean;
  disableAsterisk?: boolean;
  showInfoIcon?: boolean;
  infoIconTooltip?: string;
  showFieldHasValue?: boolean;
  autofocus?: boolean;
}
